import { render, staticRenderFns } from "./PolicyContent.vue?vue&type=template&id=0c0e5adc&scoped=true"
import script from "./PolicyContent.vue?vue&type=script&lang=js"
export * from "./PolicyContent.vue?vue&type=script&lang=js"
import style0 from "./PolicyContent.vue?vue&type=style&index=0&id=0c0e5adc&prod&lang=less&scoped=true"
import style1 from "./PolicyContent.vue?vue&type=style&index=1&id=0c0e5adc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0e5adc",
  null
  
)

export default component.exports